import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Refund = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 pt-20 pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Button */}
          <motion.button
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-primary hover:text-primary/80 mb-8 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Home
          </motion.button>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-12 text-center"
          >
            <h1 className="text-4xl md:text-5xl font-heading font-black mb-4" data-testid="refund-title">Refund Policy</h1>
            <div className="space-y-1">
              <p className="text-muted-foreground">Last updated: January, 2026</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="glass-effect border border-primary/10 p-8 md:p-12 space-y-8"
          >
            <section>
              <h2 className="text-2xl font-heading font-bold mb-4">1. Commitment to Consumer Protection Rights</h2>
              <p className="text-muted-foreground leading-relaxed">
                Skies Seven is committed to full compliance with the Consumer Protection Law of the Sultanate of Oman. <strong>We guarantee that you will be refunded in accordance with your consumer protection rights</strong> in the event of service failure, cancellation, or significant alteration of the event that affects the core service promised.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold mb-4">2. Right to Refund for Event Cancellation</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                In strict adherence to consumer rights regarding the delivery of services:
              </p>
              <ul className="list-disc pl-5 text-muted-foreground space-y-2">
                <li>
                  <strong>Cancellation by Organizer:</strong> If the Oman Drone Carnival is cancelled by the organizer, you are entitled to a <strong>full refund</strong> of the ticket price, with no deduction of administrative fees, as per applicable laws.
                </li>
                <li>
                  <strong>Significant Rescheduling:</strong> If the event is rescheduled to a date that you cannot attend, you reserve the right to request a full refund, provided the request is made within the statutory timeframe announced at the time of the change.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold mb-4">3. Attendee Cancellation & Transfer</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                While we uphold your rights regarding our failure to deliver, voluntary cancellations by the attendee (due to personal reasons, travel issues, or scheduling conflicts) are generally non-refundable unless otherwise mandated by specific consumer protection provisions.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                However, to ensure fair treatment, we allow ticket transfers to another person up to 48 hours before the event start date. Please contact support to facilitate a transfer.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold mb-4">4. Force Majeure and Consumer Rights</h2>
              <p className="text-muted-foreground leading-relaxed">
                In the event of "Force Majeure" (extraordinary circumstances beyond control such as pandemics or government shutdowns), we will process refunds or ticket rollovers in accordance with the guidance issued by the Public Authority for Consumer Protection (PACP) and relevant legal standards applicable at that time.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold mb-4">5. Processing of Refunds</h2>
              <p className="text-muted-foreground leading-relaxed">
                Approved refunds will be processed back to the original payment method used at the time of purchase. Please allow 7-14 business days for the funds to appear in your account, depending on your bank's processing times.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold mb-4">6. Contact Us</h2>
              <p className="text-muted-foreground leading-relaxed">
                For any refund requests or inquiries regarding your consumer rights, please contact our support team at <a href="mailto:info@skiesseven.com" className="text-primary hover:underline">info@skiesseven.com</a> or visit our website at <a href="https://skiesseven.com" className="text-primary hover:underline">skiesseven.com</a>.
              </p>
            </section>
          </motion.div>
        </div>
    </div>
  );
};

export default Refund;